<template>
    <div class="com-crosswise-app">
        <a :href="`${baseUrl}/myapp/detail.htm?apkName=${item.pkgName}&info=${item.apkMd5}`" target="_blank" class="icon">
            <img class="lazy" :data-original="`${item.iconUrl}`" width="72" height="72" :src="item.iconUrl"/>
        </a>
        <div class="app-info">
            <a class="name" target="_blank" :href="`myapp/detail.htm?apkName=${item.pkgName}&info=${item.apkMd5}`">{{item.appName}}</a>
            <div class="down-count">
              下载<format-down-nums :downloadNums="item.appDownCount"/>次
            </div>
            <div class="ins-btn-box">
                <com-ins-btn :ex_url="item.apkUrl" :asistanturlid="comAsistanturlid" :appname="item.appName" :apk="item.pkgName" :appicon="item.iconUrl"/>
            </div>
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
import formatDownNums from '../../components/format-down-nums.vue';
import comInsBtn from '../../components/com-ins-btn.vue';
import { baseUrl } from '../../utils/tools';
export default {
  name: 'com-crosswise-app',
  props: ['comListApp', 'item'],
  data () {
    return {
      comAsistanturlid: '990499',
      baseUrl: ''
    };
  },
  components: {
    'format-down-nums': formatDownNums,
    'com-ins-btn': comInsBtn
  },
  mounted () {
    this.baseUrl = baseUrl;
  }
};
</script>
